export const DEBOUNCE_SAVE_DELAY_MS = 1000;
export const DATE_FORMAT = 'YYYY-MM-DD';

export const controls = ['hotel', 'airport', 'car', 'start', 'finish'];
